import axios, {AxiosResponse} from 'axios';
import {
    AdminPrivilegeResponse, AdminUserAuditTrailsResponse, AdminUserRetrieveResponse,
    AdminUsersRetrieveResponse, AuditTrailRequest, BaseListRequest,
    LogoutResponse, SearchHistoryResponse, SystemAdminReceiverRetrieveResponse, UserAuthResponse
} from '@/model/CommonModel';
import AppSession from '@/store/AppSession';

export default class SystemAdminApi {

    public static getAdminPageAccessPrivilege(userKey: number | string): Promise<AdminPrivilegeResponse> {
        return axios
            .get(`/1.0/system-admin/users/${userKey}/accessible`)
            .then((res: AxiosResponse) => res.data);
    }

    public static adminAuthentication(): Promise<UserAuthResponse> {
        return axios
            .get(`/1.0/system-admin/users/${AppSession.getUserKey()}/auth`)
            .then((res: AxiosResponse) => res.data);
    }

    public static systemAdminLogout(reason: string): Promise<LogoutResponse> {
        return axios
            .post(`/1.0/system-admin/users/${AppSession.getUserKey()}/logout`, {reason})
            .then((res: AxiosResponse) => res.data);
    }

    public static retrieveDataExpSearchInfo(fileName: string, fullText: string): Promise<SearchHistoryResponse> {
        return axios
            .get(`/1.0/system-admin/search/export-history`, {params: {fileName, fullText}})
            .then((res: AxiosResponse) => res.data);
    }

    public static retrieveSubmissionSearchInfo(batchNo: string, fullText: string): Promise<SearchHistoryResponse> {
        return axios
            .get(`/1.0/system-admin/search/submission-history`, {params: {batchNo, fullText}})
            .then((res: AxiosResponse) => res.data);
    }

    public static getSystemAdminUserList(params: BaseListRequest): Promise<AdminUsersRetrieveResponse> {
        return axios
            .get(`/1.0/system-admin/user/users`, {params})
            .then((res: AxiosResponse) => res.data);
    }

    public static getSystemAdminUserInfo(userKey: string | number): Promise<AdminUserRetrieveResponse> {
        return axios
            .get(`/1.0/system-admin/user/users/${userKey}`)
            .then((res: AxiosResponse) => res.data);
    }

    public static getSystemAdminUserAuditTrail(data: AuditTrailRequest): Promise<AdminUserAuditTrailsResponse> {
        const userKey = data.userKey;
        const params = {itemId: data.itemId};
        return axios
            .get(`/1.0/system-admin/user/users/${userKey}/audit-trail`, {params})
            .then((res: AxiosResponse) => res.data);
    }

    public static saveSystemAdminUser(userKey: string | number, params: any = {}): Promise<AdminUserRetrieveResponse> {
        return axios
            .put(`/1.0/system-admin/user/users/${userKey}`, params)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveSystemAdminReceiver(): Promise<SystemAdminReceiverRetrieveResponse> {
        return axios
            .get(`/1.0/system-admin/receiver`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static saveSystemAdminReceiver(params: any = {}): Promise<any> {
        return axios
            .put(`/1.0/system-admin/receiver`, params)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveSystemAdminReceiverAuditTrail(itemId: string): Promise<any> {
        const params = {itemId};
        return axios
            .get(`/1.0/system-admin/receiver/audit-trail`, {params})
            .then((res: AxiosResponse) => res.data);
    }

}
